import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

const EMPTY = { contact_name: "", company: "", email: "", phone: "", website: "", message: "", hp_field: "" };
export const inputCls = "w-full px-3 py-2.5 border border-slate-300 rounded-sm text-sm focus:outline-none focus:border-[#0A192F]";

export const ContactFields = ({ f, set, prefix }) => (
  <div className="grid sm:grid-cols-2 gap-4">
    <input data-testid={`${prefix}-company`} required placeholder="Business name *" className={inputCls} value={f.company} onChange={(e) => set("company", e.target.value)} />
    <input data-testid={`${prefix}-name`} required placeholder="Your name *" className={inputCls} value={f.contact_name} onChange={(e) => set("contact_name", e.target.value)} />
    <input data-testid={`${prefix}-email`} required type="email" placeholder="Email *" className={inputCls} value={f.email} onChange={(e) => set("email", e.target.value)} />
    <input data-testid={`${prefix}-phone`} placeholder="Phone" className={inputCls} value={f.phone} onChange={(e) => set("phone", e.target.value)} />
  </div>
);

export const SponsorEnquiryForm = ({ packages, selected, onSelect }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/sponsorship/enquiries", { ...f, package_id: selected || null });
      setDone(true);
    } catch (err) { toast.error(formatApiError(err?.response?.data?.detail) || "Could not send enquiry"); }
    finally { setBusy(false); }
  };

  if (done) return (
    <div data-testid="sponsor-enquiry-success" className="mt-8 border border-emerald-200 bg-emerald-50 rounded-sm p-8 text-center">
      <CheckCircle2 className="w-10 h-10 text-emerald-600 mx-auto" />
      <div className="font-display text-2xl uppercase tracking-tight mt-3 text-[#0A192F]">Thanks — we got it!</div>
      <p className="text-sm text-slate-600 mt-1">The CBR team will reach out within 2 business days.</p>
    </div>
  );

  return (
    <form onSubmit={submit} className="mt-8 space-y-4" data-testid="sponsor-enquiry-form">
      <ContactFields f={f} set={set} prefix="enquiry" />
      <input aria-hidden="true" tabIndex={-1} autoComplete="off" className="hidden" value={f.hp_field} onChange={(e) => set("hp_field", e.target.value)} />
      <div className="grid sm:grid-cols-2 gap-4">
        <input data-testid="enquiry-website" placeholder="Website" className={inputCls} value={f.website} onChange={(e) => set("website", e.target.value)} />
        <select data-testid="enquiry-package" className={inputCls} value={selected} onChange={(e) => onSelect(e.target.value)}>
          <option value="">Package — not sure yet</option>
          {packages.map((p) => <option key={p.id} value={p.id}>{p.name} — {p.tagline}</option>)}
        </select>
      </div>
      <textarea data-testid="enquiry-message" rows={4} placeholder="Anything we should know? (goals, budget, events you'd like to back)" className={inputCls} value={f.message} onChange={(e) => set("message", e.target.value)} />
      <button data-testid="enquiry-submit" disabled={busy}
        className="bg-[#0A192F] hover:bg-[#12294a] text-white px-7 py-3 text-sm font-semibold uppercase tracking-wider rounded-sm disabled:opacity-60 transition-colors">
        {busy ? "Sending…" : "Send Enquiry"}
      </button>
    </form>
  );
};
